'use strict';

import baseConfig from './base';

let config = {
  databaseURL: 'https://trybe.firebaseio.com',
  dbApiKey: 'AIzaSyDfG5TcsOCdKwXIGP2TIpE0ejUi_HNPi_w',
  dbProjectId: 'firebase-trybe',
  dbEnv: 'prod',
  authClientID: 'GXx4OUOEg0kNZdORsBkxK4ID3U86L8TD',
  authDomain: 'trybe.auth0.com',
  stripePubKey: 'pk_live_A5hbe7S9l9MGlROAgyzjndD4',
  amplitudeApiKey: '877e19a3a282462ad44045ecd3c6ecb4',

  //Lets Sid Paulson exclude sales from places like Mexico, which has tough VAT policies
  geoTargetlyId: '-MPlF7Kkk7-lMEw2dTbT',
};

export default Object.freeze(Object.assign({}, baseConfig, config));



// WEBPACK FOOTER //
// ./src/config/dist.js